"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var typography_1 = __importDefault(require("@cdo/apps/componentLibrary/typography"));
var constants_1 = require("@cdo/apps/componentLibrary/common/constants");
var checkbox_module_scss_1 = __importDefault(require("./checkbox.module.scss"));
/**
 * ### Production-ready Checklist:
 * * (✔) implementation of component approved by design team;
 * * (✔) has storybook, covered with stories and documentation;
 * * (✔) has tests: test every prop, every state and every interaction that's js related;
 * * (see apps/test/unit/componentLibrary/CheckboxTest.jsx)
 * * (?) passes accessibility checks;
 *
 * ###  Status: ```Ready for dev```
 *
 * Design System: Checkbox Component.
 * Can be used to render a checkbox or as a part of bigger/more complex components (e.g. Checkbox Dropdown).
 */
var Checkbox = function (_a) {
    var label = _a.label, checked = _a.checked, onChange = _a.onChange, name = _a.name, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.indeterminate, indeterminate = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'm' : _d;
    var checkboxRef = (0, react_1.useRef)(null);
    var bodyTextSize = constants_1.componentSizeToBodyTextSizeMap[size];
    (0, react_1.useEffect)(function () {
        if (checkboxRef === null || checkboxRef === void 0 ? void 0 : checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate;
        }
    }, [checkboxRef, indeterminate]);
    return (react_1.default.createElement("label", { className: (0, classnames_1.default)(checkbox_module_scss_1.default.label, checkbox_module_scss_1.default["label-".concat(size)]) },
        react_1.default.createElement("input", { type: "checkbox", ref: checkboxRef, name: name, value: value, checked: checked, disabled: disabled, onChange: onChange }),
        react_1.default.createElement("i", { className: "fa-solid" }),
        label && (react_1.default.createElement(typography_1.default, { semanticTag: "span", visualAppearance: bodyTextSize }, label))));
};
exports.default = Checkbox;
